import React, { useState, useEffect } from "react";
import { Backdrop, CircularProgress, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import { HttpService } from "../../apiAuthorization/httpService";
import { authenticationService } from '../../apiAuthorization/authenticationService';
import { RemoveOfflineDatas } from '../../offline/dataService/offlineData';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    }
}));

export const Context = React.createContext(null);

export const SiteContext = props => {
    const classes = useStyles();
    const [sites, setSites] = useState([]);
    const [defaultSite, setDefaultSite] = useState([]);
    const [open, setOpen] = useState(false);
    const [siteLoading, setSiteLoading] = useState([]);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const contextValue = {
        sites,
        setSites,
        defaultSite,
        setDefaultSite,
        siteLoading
    };

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const getSiteByUserName = () => {
        let userName;
        if (!authenticationService.currentUserValue) {
            return;
        }
        else {
            userName = authenticationService.currentUserValue.Username;
        }

        setOpen(true);
        setSiteLoading(true);
        HttpService.post("/Home/GetSitesByUserName", { userName: userName })
            .then((result) => {
                if (result !== null) {
                    setSites(result);
                    let site = JSON.parse(sessionStorage.getItem("defaultSite"));
                    if (site !== null && site.id !== result[0].id) {
                        RemoveOfflineDatas(site.id);
                    }
                    setDefaultSite(result[0]);
                    sessionStorage.setItem("defaultSite", JSON.stringify(result[0]));
                }
                else {
                    setErrorMessage("Unable to obtain site information, please contact the administrator.");
                    setOpenError(true);
                }
                setOpen(false);
                setSiteLoading(false);
            },
                (error) => {
                    console.log(error);
                    setOpen(false);
                    setSiteLoading(false);
                });
    };

    useEffect(() => {   
        getSiteByUserName();
        //eslint-disable-next-line 
    }, [authenticationService.currentUserValue]);

    return (
        <>
            <Backdrop className={classes.backdrop} open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                <Alert onClose={closeErrorSnackbar} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>
            <Context.Provider value={contextValue}>{props.children}</Context.Provider>
        </>
    );
};
